export const MASKS = {
  phoneUS: '(000) 000-0000',
} as const;
